<div class="image-carousel-container">
  <div class="content">
    <swiper
      [slidesPerView]="groupSize"
      [slidesPerGroup]="groupSize"
      [spaceBetween]="30"
      [navigation]="true"
      [pagination]="{ clickable: true , showNavigationOnlyDesktop:showNavigationOnlyDesktop}"
      (activeIndexChange)="updateSlide($event)"
      [index]="activeSlide"
    >
      <ng-template swiperSlide *ngFor="let item of items">
        <img *ngIf="item.type=='image'; else video"
          class="{{ project }}"
          [lazyLoad]="item.url.lazyLoad"
          [defaultImage]="item.url.default"
          [errorImage]="item.url.error"
          [alt]="item.altText"
          [title]="item.titleText"
          src="#" />
        <ng-template #video>
          <kion-youtube
            [videoId]="item.id"
            [quality]="item.quality"
            [startSeconds]="item.startSeconds"
            [endSeconds]="item.endSeconds"
          ></kion-youtube>
        </ng-template>
      </ng-template>
    </swiper>
  </div>
</div>